import gsap from 'gsap';
export default class Preload {
  constructor(element) {
    this.element = element;
    this.bouton = this.element.querySelector('.compris');
    this.init();
  }
  init() {
    const time = { time: 0 };
    const preload = document.querySelector('.js-preload');
    if (localStorage.getItem('visit') == 'no') {
      preload.classList.toggle('preload-none');
    }
    if (localStorage.getItem('visit') != 'no') {
      localStorage.setItem('visit', 'yes');
    }
    if (localStorage.getItem('visit') == 'yes') {
      gsap.to(time, {
        time: 10,
        duration: 10,
        onUpdate: () => {
          const timer = document.querySelector('.js-timer');
          const percent = Math.round(time.time);
          timer.textContent = percent;
        },
        onComplete: () => {
          const preload = document.querySelector('.js-preload');
          preload.classList.add('preload-end');
          localStorage.setItem('visit', 'no');
        },
      });
    }
    this.bouton.addEventListener('click', this.activerOk.bind(this));
  }
  activerOk() {
    const time = { time: 0 };
    gsap.to(time, {
      time: 0,
      duration: 0,
      onComplete: () => {
        const preload = document.querySelector('.js-preload');
        preload.classList.add('preload-end');
        localStorage.setItem('visit', 'no');
      },
    });
  }
}
